function isIE() {
  //ie?
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    return true;
  } else {
    return false;
  }
}

export default {
  getOS: function () {
    //判断所处操作系统
    const lowerUserAgent = navigator.userAgent.toLowerCase();

    const isMac = ["Mac68K", "MacPPC", "Macintosh", "MacIntel"].includes(
      navigator.platform
    );
    if (isMac) return "Mac";

    const isIphone = lowerUserAgent.indexOf("iphone") > -1;
    const isIpad = lowerUserAgent.indexOf("ipad") > -1;
    if (isIphone || isIpad) return "iOS";

    const isLinux = String(navigator.platform).indexOf("Linux") > -1;
    const bIsAndroid =
      lowerUserAgent.toLowerCase().match(/android/i) == "android";
    if (isLinux) {
      if (bIsAndroid) return "Android";
      else return "Linux";
    }

    const isWin = ["Win32", "Win64", "wow64"].includes(navigator.platform);
    if (isWin) {
      const winVersions = {
        "Windows nt 5.0": "Win2000",
        "Windows 2000": "Win2000",
        "Windows nt 5.1": "WinXP",
        "Windows XP": "WinXP",
        "Windows nt 5.2": "Win2003",
        "Windows 2003": "Win2003",
        "Windows nt 6.0": "WinVista",
        "Windows Vista": "WinVista",
        "Windows nt 6.1": "Win7",
        "Windows 7": "Win7",
        "windows nt 6.2": "Win8",
        "Windows 8": "Win8",
        "windows nt 10.0": "Win10",
        "Windows 10": "Win10",
        "Windows 11": "Win11",
      };
      const winVersion = Object.keys(winVersions).find(
        (key) => lowerUserAgent.indexOf(key) > -1
      );
      if (winVersion) return winVersions[winVersion];
      return "Win";
    }

    const isUnix = navigator.platform == "X11" && !isWin && !isMac;
    if (isUnix) return "Unix";

    return "其他";
  },
  getBrowser: function () {
    const Sys = {};
    const ua = navigator.userAgent.toLowerCase();
    const kklClientRegex = /(kklClientInfo)\(.*?\)/;
    const kklClientResult = ua.match(kklClientRegex);
    if(kklClientResult) {
      return {
        browser: 'webview',
        ver: ''
      }
    }

    const qqre = /(qqbrowser).*?([\d.]+)/; //qq
    const edgere = /(edge).*?([\d.]+)/; //edge
    const re = /(msie|firefox|chrome|opera|version|maxthon).*?([\d.]+)/; //ie,火狐，chrome，opera，safari，遨游
    let m;
    if (ua.indexOf("se 2.x") > -1) {
      //搜狗浏览器，版本号无法获取
      m = ["搜狗浏览器/", "搜狗浏览器", ""];
    } else {
      if (ua.match(qqre)) {
        m = ua.match(qqre);
      } else if (ua.match(edgere)) {
        m = ua.match(edgere);
      } else if (ua.match(re)) {
        m = ua.match(re);
      } else {
        if (isIE()) {
          m = ["ie/11.0", "ie", "11.0"];
        } else {
          m = ["其他浏览器/", "其他浏览器", ""];
        }
      }
    }
    //safari，ie，遨游需要替换名称
    Sys.browser = m[1]
      .replace(/version/, "safari")
      .replace(/msie/, "ie")
      .replace(/maxthon/, "遨游");
    Sys.ver = m[2] || "";
    return Sys;
  },
  getResolution: function () {
    let resolution = "";
    try {
      resolution = `${window.screen.width}*${window.screen.height}`;
    } catch (error) {}
    return resolution;
  },
  getDPI: function () {
    return window.devicePixelRatio;
  },
  getUA: function () {
    let ua = "";
    try {
      ua = navigator.userAgent;
    } catch (error) {}

    return ua;
  },
};
